import { AgentState, AgentCurrentState } from './agent-state';
import { parseBooleanString, parseInteger } from '../../../util/utility';
import { CXoneEvent } from './cxone-event';

/**
 * Class to capture agent state event
 */
export class AgentStateEvent extends CXoneEvent {
  currentState: AgentCurrentState = {
    state: '',
    reason: '',
    startTime: 0,
    acwTimeout: 0,
    isACW: false
  };
  nextState!: AgentState;
  nNextState!: AgentState;

  /**
   * This method to parse agent state event data
   * @param data -
   * @example -
   * ```
   *parse(data);
   * ```
   */
  public parse(data: { [key: string]: string | any }): void {
    this.currentState.state = data.CurrentState;
    this.currentState.reason = data.CurrentOutReason;
    this.currentState.startTime = data.StartTimeUTC
      ? new Date(data.StartTimeUTC).getTime()
      : 0;
    this.currentState.acwTimeout = data.AcwTimeout
      ? parseInteger(data.AcwTimeout)
      : 0;
    this.currentState.isACW = parseBooleanString(data.IsAcw);

    if (typeof data.NextStates === 'object') {
      for (let i = 0; i < data.NextStates.length; i++) {
        if (i === 0) {
          const nState: AgentState = {
            state: data.NextStates[i].State,
            reason: data.NextStates[i].OutReason,
            isACW: parseBooleanString(data.NextIsAcw),
          };
          this.nextState = nState;
        } else if (i === 1) {
          const nnState: AgentState = {
            state: data.NextStates[i].State,
            reason: data.NextStates[i].OutReason,
            isACW: parseBooleanString(data.NextIsAcw),
          };
          this.nNextState = nnState;
        }
      }
    }
  }
}
